





























import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import { requiredString } from "@/tool/validation";
import { HandbookCategory, HandbookSubCategory } from "@/api";

@Component
export default class HandbookCategroyForm extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly editName!: string;
  @Prop() readonly action!: string;
  @Prop() readonly payloadSubCategory!: HandbookSubCategory;
  @Prop() readonly payloadCategory!: HandbookCategory;
  @Ref("form") form!: VForm;
  @Watch("editName", { immediate: true, deep: true })
  onNameChange(newVal: string) {
    if (newVal) {
      this.name = newVal;
    }
  }

  name = this.editName || "";
  loading = false;
  required = [requiredString];

  async save() {
    const valid = this.form.validate();

    let payload;
    if (this.payloadCategory) payload = this.payloadCategory;
    if (this.payloadSubCategory) payload = this.payloadSubCategory;

    if (valid && payload) {
      payload.name = this.name;
      this.loading = true;
      await this.$store.dispatch(this.action, payload);
      this.loading = false;
      this.close();
    } else {
      alert("failed to submit");
    }
  }

  close() {
    this.form.reset();
    this.$emit("close");
  }
}
